// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"1ee684b6","78":"c4fba6e4","167":"c1444825","192":"5e63745c","651":"9b6a4020","711":"faa1e5d4","765":"d280c298","824":"867cc035","900":"422dfba2"}[chunkId] + ".chunk.css";
};